import { useEffect, useState } from 'react';

const SHOW_SECONDS_STORAGE_KEY = 'schedule-view-show-seconds';
export const useShowSeconds = () => {
  const [showSeconds, setShowSeconds] = useState(false);

  useEffect(() => {
    const showSecondsValue = localStorage.getItem(SHOW_SECONDS_STORAGE_KEY);

    if (showSecondsValue === null) {
      localStorage.setItem(SHOW_SECONDS_STORAGE_KEY, 'false');
    } else {
      setShowSeconds(showSecondsValue === 'true');
    }
  }, []);

  const toggleShowSeconds = () => {
    setShowSeconds(prev => !prev);
    localStorage.setItem(SHOW_SECONDS_STORAGE_KEY, String(!showSeconds));
  };

  return {
    showSeconds,
    toggleShowSeconds,
  };
};
